import dayjs from 'dayjs';
import PlanYear from 'model/PlanYear';
import {
  SHORT_MONTH_DATE_FORMAT,
  LONG_MONTH_DATE_FORMAT,
  convertLanguageToLocale,
} from 'utils/dateUtil';
import { NO_END_DATE } from 'constants/languageConstants';
import { getText } from 'utils/stringUtil';

const noEndDateText = (language?: string) =>
  getText(NO_END_DATE, language === 'SPANISH' ? 'SPANISH' : 'ENGLISH');

export const formatPlanYearLabel = (planYear: PlanYear, language?: string) => {
  const startDate = dayjs(planYear.startDate)
    .locale(convertLanguageToLocale(language))
    .format(SHORT_MONTH_DATE_FORMAT);
  const endDate = planYear.endDate
    ? dayjs(planYear.endDate)
        .locale(convertLanguageToLocale(language))
        .format(SHORT_MONTH_DATE_FORMAT)
    : noEndDateText(language);

  return `${planYear.name} (${startDate} - ${endDate})`;
};

export const formatPlanYear = (planYear: PlanYear, language?: string) => {
  const startDate = dayjs(planYear.startDate)
    .locale(convertLanguageToLocale(language))
    .format(LONG_MONTH_DATE_FORMAT);
  const endDate = planYear.endDate
    ? dayjs(planYear.endDate)
        .locale(convertLanguageToLocale(language))
        .format(LONG_MONTH_DATE_FORMAT)
    : noEndDateText(language);

  return `${startDate} - ${endDate}`;
};
